import React from 'react';

// Styles
import styles from './index.module.sass';

const urlBanner1 =
  'https://webimages.terramarbrands.com.mx/webpage/terrapuntos/terrapuntos-dashboard.png';
const urlBanner2 =
  'https://webimages.terramarbrands.com.mx/webpage/terrapuntos/logo-terrapuntos.png';

export default function BannerTerrapuntosDetail({ screenSize }) {
  return (
    <div className={`${styles.BannerSide} ${styles[screenSize]}`}>
      <div
        className={styles.mainContainer}
        style={{
          flexDirection: (screenSize === 'phone' && 'column') || 'row',
        }}>
        <div className={styles.textContainer}>
          {screenSize !== 'phone' && (
            <div>
              <label className={styles.text}>DETALLE DE MIS:</label>
            </div>
          )}
          <div
            className={styles.imageContainer2}
            style={{
              backgroundImage: `url(${(screenSize === 'phone' && urlBanner2) || urlBanner2})`,
            }}></div>
          <div className={styles.description}>
            Aquí podras consultar cuantos TERRApuntos tienes acumulados en este momento, que puedes
            canjear por descuentos en tus pedidos.
          </div>
        </div>
        {screenSize !== 'phone' && (
          <div
            className={styles.imageContainer}
            style={{
              backgroundImage: `url(${(screenSize === 'phone' && urlBanner1) || urlBanner1})`,
            }}></div>
        )}
      </div>
    </div>
  );
}
